/*
 * Account navigation (Javi, 2026-10-24): choosing the account page you are already on must not reload it. A click on the current
 * page's link in the sidebar or in the account tabs scrolls to the top instead (smooth only without prefers-reduced-motion).
 * The profile's in-page items (data-nc-spy) are handled by assets/nc-profile-spy.js and are left alone.
 */
(function () {
  if (typeof document === 'undefined' || window.__ncAccountNav) return;
  window.__ncAccountNav = true;
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var a = event.target.closest && event.target.closest('.nc-sidebar a[aria-current="page"], .nc-account-tabs a[aria-current="page"]');
    if (!a || a.hasAttribute('data-nc-spy')) return;
    event.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
  // QA 2026-10-31: on a narrow screen the tab bar scrolls, so the current tab is brought into view (never cut at the edge) on load;
  // only the bar scrolls, the page does not move
  function showCurrent() {
    var list = document.querySelector('.nc-account-tabs__list'), cur = list && list.querySelector('[aria-current="page"]');
    if (!cur || list.scrollWidth <= list.clientWidth) return;
    list.scrollLeft = Math.max(0, cur.offsetLeft - (list.clientWidth - cur.offsetWidth) / 2);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', showCurrent); else showCurrent();

  // Where am I (QA 2026-11-01). (1) «Privacidad» is a section of Tu cuenta: with #privacidad in the URL it is the one active item instead of Tu cuenta.
  function setCurrent(a, current, kind) {
    var li = a.closest('li');
    if (current) { a.setAttribute('aria-current', kind); if (li) li.classList.add('nc-sidebar__item--active'); }
    else { a.removeAttribute('aria-current'); if (li) li.classList.remove('nc-sidebar__item--active'); }
  }
  function syncPrivacy() {
    var priv = document.querySelector('.nc-sidebar a[href$="#privacidad"]');
    if (!priv) return;
    var base = priv.getAttribute('href').split('#')[0];
    var acct = document.querySelector('.nc-sidebar a[href="' + base + '"]');
    if (!acct || location.pathname !== base.split('?')[0]) return; // only on the Tu cuenta page itself
    var on = location.hash === '#privacidad';
    setCurrent(acct, !on, 'page');
    setCurrent(priv, on, 'location');
  }
  window.addEventListener('hashchange', syncPrivacy);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncPrivacy); else syncPrivacy();

  // (2) After moving between personal screens with the account navigation, keyboard and screen-reader focus lands on the new screen's title
  // (once: the flag is set by the click and read by the next page; a page with a #hash keeps the browser's own anchor behaviour)
  var FOCUS_KEY = 'nc-nav-focus';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.nc-sidebar a[href], .nc-account-tabs a[href], .nc-account-menu a[href]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    try { sessionStorage.setItem(FOCUS_KEY, '1'); } catch (err) { /* storage blocked: no focus move, nothing breaks */ }
  });
  function focusTitle() {
    var flag = null;
    try { flag = sessionStorage.getItem(FOCUS_KEY); sessionStorage.removeItem(FOCUS_KEY); } catch (err) { return; }
    if (!flag || location.hash) return;
    var h1 = document.querySelector('main h1, #MainContent h1');
    if (!h1) return;
    if (!h1.hasAttribute('tabindex')) h1.setAttribute('tabindex', '-1');
    h1.focus({ preventScroll: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusTitle); else focusTitle();
})();
